var map = {
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"admin-admin-module~base-base-module~capacity_planner-cp-module~night_shifts-ns-module",
		"common",
		"admin-admin-module"
	],
	"./base/base.module": [
		"./src/app/base/base.module.ts",
		"admin-admin-module~base-base-module~capacity_planner-cp-module~night_shifts-ns-module",
		"common",
		"base-base-module"
	],
	"./capacity_planner/cp.module": [
		"./src/app/capacity_planner/cp.module.ts",
		"admin-admin-module~base-base-module~capacity_planner-cp-module~night_shifts-ns-module",
		"common",
		"capacity_planner-cp-module"
	],
	"./night_shifts/ns.module": [
		"./src/app/night_shifts/ns.module.ts",
		"admin-admin-module~base-base-module~capacity_planner-cp-module~night_shifts-ns-module",
		"common",
		"night_shifts-ns-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;